import types from '../../types';

export default {
  [types.SET_PLACE_GOOGLE]: (state, payload) => {
    state.predictions.google = payload;
  },
  [types.SET_PLACE_API]: (state, payload) => {
    state.predictions.api = payload;
  },
};
